import Button from '@orn/shared-web/components/Button/Button';
import Modal from '@orn/shared-web/components/Modal';

interface IDeleteAccountModalProps {
  isOpen: boolean;
  isDeleting: boolean;
  /** Error from a failed delete attempt; undefined hides the message. */
  error?: string;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Confirmation step for self-serve account deletion. Spells out that the action
 * is permanent and also removes the user's family before handing the confirmed
 * intent back to the caller via `onConfirm`. Purely presentational — the parent
 * owns the mutation and the post-delete redirect.
 */
const DeleteAccountModal = ({ isOpen, isDeleting, error, onClose, onConfirm }: IDeleteAccountModalProps) => {
  return (
    <Modal isOpen={isOpen} onOpenChange={(open) => !open && onClose()} size="sm">
      <Modal.Header onClose={onClose}>Delete account?</Modal.Header>
      <Modal.Body className="gap-5 px-6 pb-6">
        <div className="text-secondary text-sm">
          This permanently deletes your account and your family's data, and can't be undone.
        </div>
        {error && <span className="text-error-primary w-full text-sm">{error}</span>}
        <div className="flex w-full justify-end gap-3">
          <Button color="secondary" size="md" onClick={onClose} isDisabled={isDeleting}>
            Cancel
          </Button>
          <Button color="primary-destructive" size="md" onClick={onConfirm} isLoading={isDeleting} showTextWhileLoading>
            {isDeleting ? 'Deleting' : 'Delete account'}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteAccountModal;
